import { TOOLS } from "../../constant/tools";

import { GenericToolCall } from "./Chat/Tools/GenericToolCall";
import { ListDocumentsTool } from "./Chat/Tools/ListDocumentsTool";
import { ReadDocumentRangeTool } from "./Chat/Tools/ReadDocumentRangeTool";
import { ReplaceTextTool } from "./Chat/Tools/ReplaceTextTool";
import { RetrieveLegalDocsTool } from "./Chat/Tools/RetrieveLegalDocsTool";
import { FsNavigateTool } from "./Chat/Tools/FsNavigateTool";
import { FsReadSliceTool } from "./Chat/Tools/FsReadSliceTool";
import { FsCreateFileTool } from "./Chat/Tools/FsCreateFileTool";

import { ToolCallProps } from "../types/ToolCall";

export function ToolCall(props: ToolCallProps) {
	switch (props.name) {
		case TOOLS.RETRIEVE_LEGAL_DOCS:
		case TOOLS.FIND_LEGAL_SOURCES:
			return <RetrieveLegalDocsTool {...(props as any)} />;
		case TOOLS.LIST_DOCUMENTS:
			return <ListDocumentsTool {...props} />;
		case TOOLS.READ_DOCUMENT_RANGE:
			return <ReadDocumentRangeTool {...props} />;
		case TOOLS.REPLACE_TEXT:
			return <ReplaceTextTool {...(props as any)} />;
		case TOOLS.FS_NAVIGATE:
			return <FsNavigateTool {...(props as any)} />;
		case TOOLS.FS_READ_SLICE:
			return <FsReadSliceTool {...(props as any)} />;
		case TOOLS.FS_CREATE_FILE:
			return <FsCreateFileTool {...(props as any)} />;
		default:
			return <GenericToolCall {...props} />;
	}
}
